import { useEffect, useState } from "react"
import Grid from "@material-ui/core/Grid"

import { Button } from "@progress/kendo-react-buttons"

import { Input } from "@progress/kendo-react-inputs"
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"


import { fetchRequests, updateRequest } from "../Services/ApiService"
import { process } from "@progress/kendo-data-query";

import ActionsCell from "./ActionsCell"

import { ColumnMenu } from "./ColumnMenu";

import {
  Grid as DataTable,
  GridColumn as DataTableColumn,
} from "@progress/kendo-react-grid"

export default function Inbox(props) {

  const { backgroundProcessor, notificationCreate, appMode } = props

  const [gridData, setGridData] = useState([])
  const [orderControls, setOrderControls] = useState({
    skip: 0,
    take: 20,
  })

  const [gridDataState, gridChange] = useState(orderControls)


  const [showAccept, setShowAccept] = useState(false)
  const [selectedAccept, setSelectedAccept] = useState(false)

  const [showReject, setShowReject] = useState(false)
  const [selectedReject, setSelectedReject] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [processedData, setprocessedData] = useState(
    process([], gridDataState)
  );

  const handleGridDataStateChange = (e) => {
    gridChange(e.dataState)
  }

  useEffect(async () => {
    backgroundProcessor?.add()

    let fetchedRequests = await fetchRequests()

    fetchedRequests = fetchedRequests.data.requests

    fetchedRequests = fetchedRequests.filter(request => request.value.status === 'SUBMITTED')

    const filter = appMode

    if(filter !== 'Veolia'){
      fetchedRequests = fetchedRequests.filter(request => request.value.type === filter)
    }

    fetchedRequests.map(request => {
        let newDate = new Date(request.value.dateTime)

        request.value.dateTime = newDate
    })

    setGridData(fetchedRequests)
    setprocessedData(process(fetchedRequests, gridDataState));
    backgroundProcessor?.remove()
  }, [refresh])

  useEffect(() => {
    setprocessedData(process(gridData, gridDataState));
  }, [gridData, gridDataState]);

  const confirmAccept = async (e, dataItem) => {
    setSelectedAccept(dataItem)
    setShowAccept(true)
  }

  const confirmReject = async (e, dataItem) => {
    setSelectedReject(dataItem)
    setShowReject(true)
  }

  const confirmAcceptHandler = async (e) => {
    backgroundProcessor?.add()

    try{
      selectedAccept.value.status = 'APPROVED'
      await updateRequest(selectedAccept)
  
      setShowAccept(false)
      notificationCreate({
        severity: "success",
        message: "Request Accepted Succesfully",
      })

    }catch(error){
      setShowAccept(false)
      notificationCreate({
        severity: "error",
        message: "Error Submitting Request - Please Try Again",
      })
    }

    backgroundProcessor?.remove()
    setRefresh(!refresh)
  }

  const confirmRejectHandler = async (e) =>{
    backgroundProcessor?.add()

    try{
      selectedReject.value.status = 'REJECTED'
      await updateRequest(selectedReject)
  
      setShowReject(false)
      notificationCreate({
        severity: "success",
        message: "Request Rejected Succesfully",
      })

    } catch(error){
      setShowReject(false)
      notificationCreate({
        severity: "error",
        message: "Error Submitting Request - Please Try Again",
      })
    }



    backgroundProcessor?.remove()
    setRefresh(!refresh)
  }

  const CommandCell = (props) => (
    <ActionsCell {...props} confirmAccept={confirmAccept} confirmReject={confirmReject} />
  )
  return (
    <>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        style={{ padding: "1rem", border: "1px solid grey" }}
      >
        <Grid item>
          <h2 style={{ marginRight: "9vw" }}>
            {" "}
            <span
              className="k-icon k-i-inbox k-icon-48"
              style={{ color: "#7ABCCE", marginRight: "2vw" }}
            ></span>
            User Requests Inbox
          </h2>
        </Grid>
        <Grid item>
          <button className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base" onClick={e => setRefresh(!refresh)}>
            <span className="k-icon k-i-reload k-icon-16"></span>
          </button>
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        alignItems="flex-start"
        style={{ paddingBottom: "1rem", width: "15vw", paddingTop: "0.8rem" }}
      >
      </Grid>
      <Grid
        container
        item
        direction="column"
        alignItems="flex-start"
        style={{ paddingBottom: "1rem", paddingLeft: "1rem" }}
      >
        <Grid item>
          <DataTable
            style={{ height: "100%", marginTop: "1rem", fontSize: "0.75rem" }}
            data={processedData}
            pageable={true}
            sortable={true}
            {...gridDataState}
            onDataStateChange={handleGridDataStateChange}
          >
            <DataTableColumn field="value.name" title="Name"  />
            <DataTableColumn field="value.businessEmail" title="Email" width={"220px"} />
            {appMode === 'Veolia' && (<DataTableColumn field="value.type" title="System" columnMenu={ColumnMenu} />)}
            <DataTableColumn field="value.businessName" title="Business" />
            <DataTableColumn field="value.contactNumber" title="Contact No."  />
            <DataTableColumn field="value.address" title="Address" />
            <DataTableColumn field="value.postcode" title="Postcode" width={"110px"}  />
            <DataTableColumn field="value.dateTime" title="Date/Time" filter="date" format={"{0:dd/MM/yyy HH:MM:SS}"} />
            <DataTableColumn cell={CommandCell} title="Actions"  />
          </DataTable>
        </Grid>
        {showAccept && (
          <Dialog
            title={"Confirm User Acceptance"}
            onClose={(e) => setShowAccept(false)}
            height="65vh"
            width="50vw"
            style={{ border: "1px solid #E95F47" }}
          >
            <Grid
              container
              direction="column"
              alignItems="flex-start"
              style={{ marginTop: "0.3rem" }}
              spacing={3}
            >
              <Grid item>
                <p>
                  Please check all the below details are correct before confirming
                  the users access
                </p>
                <p>
                  Once confirmed the user will receive their login details shortly
                  via email
                </p>
              </Grid>
              <Grid item style={{ width: "80%" }}>
                <Input
                  label={"Name:"}
                  value={selectedAccept.value.name}
                  style={{ width: "100%" }}
                  disabled={true}
                ></Input>
              </Grid>
              <Grid item style={{ width: "80%" }}>
                <Input
                  label={"Business Name:"}
                  value={selectedAccept.value.businessName}
                  style={{ width: "100%" }}
                  disabled={true}
                ></Input>
              </Grid>
              <Grid item style={{ width: "80%" }}>
                <Input
                  label={"Email:"}
                  value={selectedAccept.value.businessEmail}
                  style={{ width: "100%" }}
                  disabled={true}
                ></Input>
              </Grid>
            </Grid>
            <DialogActionsBar>
              <>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => confirmAcceptHandler(e)}
                >
                  Confirm
                </Button>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => setShowAccept(false)}
                >
                  Cancel
                </Button>
              </>
            </DialogActionsBar>
          </Dialog>
        )}
                {showReject && (
          <Dialog
            title={"Confirm User Rejection"}
            onClose={(e) => setShowReject(false)}
            height="65vh"
            width="50vw"
            style={{ border: "1px solid #E95F47" }}
          >
            <Grid
              container
              direction="column"
              alignItems="flex-start"
              style={{ marginTop: "0.3rem" }}
              spacing={3}
            >
              <Grid item>
                <p>
                  Please confirm you would like to reject the following request
                </p>
                <p>
                  The user will not be automatically notified of this action
                </p>
              </Grid>
              <Grid item style={{ width: "80%" }}>
                <Input
                  label={"Name:"}
                  value={selectedReject.value.name}
                  style={{ width: "100%" }}
                  disabled={true}
                ></Input>
              </Grid>
              <Grid item style={{ width: "80%" }}>
                <Input
                  label={"Business Name:"}
                  value={selectedReject.value.businessName}
                  style={{ width: "100%" }}
                  disabled={true}
                ></Input>
              </Grid>
              <Grid item style={{ width: "80%" }}>
                <Input
                  label={"Email:"}
                  value={selectedReject.value.businessEmail}
                  style={{ width: "100%" }}
                  disabled={true}
                ></Input>
              </Grid>
            </Grid>
            <DialogActionsBar>
              <>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => confirmRejectHandler(e)}
                >
                  Confirm
                </Button>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => setShowReject(false)}
                >
                  Cancel
                </Button>
              </>
            </DialogActionsBar>
          </Dialog>
        )}
      </Grid>
    </>
  )
}
